import { Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { calculate } from "./calcSlice";
import { validateCalculatorData } from "./validateCalculatorData";
import { pushAlert } from "../alerts/alertSlice";
import { selectCountries } from "../citySelect/selectCitySlice";
import { useTranslation } from "react-i18next";

const Footer = ({ state, setState, setErrors }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const countries = useSelector(selectCountries);

    const handleAddPlaceButtonClick = () => {
        setState((prev) => ({
            ...prev,
            places: [
                ...prev.places,
                { weight: "", width: "", length: "", height: "" },
            ],
        }));
    };

    const handleCalculateButtonClick = () => {
        const country = countries.find(
            (country) =>
                country["ru-name"] === state["receiver-country"] ||
                country["tr-name"] === state["receiver-country"]
        );
        if (!country) {
            dispatch(
                pushAlert({
                    type: "danger",
                    message: t("calculator.select_country_error"),
                    delay: 2000,
                })
            );
            return;
        }
        const { valid, errors } = validateCalculatorData(
            state,
            state.countryHasCities
        );

        if (!valid) {
            setErrors(errors);
            return;
        }
        for (let i in state.places) {
            state.places[i] = {
                weight: Number(state.places[i].weight),
                width: Number(state.places[i].width),
                length: Number(state.places[i].length),
                height: Number(state.places[i].height),
            };
        }
        dispatch(
            calculate({
                data: state,
            })
        );
    };

    return (
        <div>
            <div className="mb-4">
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={handleAddPlaceButtonClick}
                >
                    {t("calculator.places.add_place_button")}
                </Button>
            </div>
            <div>
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        padding: "0.5rem 1.5rem",
                        width: "90%",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={handleCalculateButtonClick}
                >
                    {t("calculator.calculate_button")}
                </Button>
            </div>
        </div>
    );
};

export default Footer;
